module.exports = __webpack_public_path__ + "img/icon_qq.043affbe.png";